import script from "./AppButtonLoadMore.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppButtonLoadMore.vue?vue&type=script&setup=true&lang=ts"

import "./AppButtonLoadMore.vue?vue&type=style&index=0&id=c80884d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c80884d8"]])

export default __exports__